import { Alert, type AlertProps, Snackbar } from '@mui/material';
import { atom, useAtom } from 'jotai';
import * as React from 'react';

/**
 * NoticeManager を使って Snackbar+Alert を表示する
 */
export const noticeAtom = atom<AlertProps | undefined>(undefined);

export function NoticeManager() {
  // 新しい notice が登録されたら alert にセットする
  const [alert, setAlert] = useAtom(noticeAtom);

  const handleClose = React.useCallback((event: any, reason?: string) => {
    if (reason === 'clickaway') return; // 画面クリックでは閉じない
    setAlert(undefined);
  }, []);

  return (
    <Snackbar open={Boolean(alert)} onClose={handleClose}>
      <Alert onClose={handleClose} {...alert} />
    </Snackbar>
  );
}
